export default "__VITE_ASSET__CWrN5fuS__"